import { EditProduct } from '../Common/Edit';

export const EditProductPage = () => <EditProduct onlyAddCodes={false} />;
